import { render, staticRenderFns } from "./CmgRewardsAchievements.vue?vue&type=template&id=2f087a73&scoped=true&lang=pug"
import script from "./cmg-rewards-achievements.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-achievements.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsAchievements.vue?vue&type=style&index=0&id=2f087a73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f087a73",
  null
  
)

export default component.exports